import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { FeatureLockHelpPopupContent } from '@lib/components/FeatureLockBanner';

export default function useDocumentationHelpPopupProps(): FeatureLockHelpPopupContent {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      title: t('documentation-help-popup-title'),
      subtitle: t('documentation-help-popup-subtitle'),
      sections: [
        {
          chipLabel: t('documentation-help-section-management'),
          items: [
            {
              title: t('documentation-help-bulk-management-title'),
              description: t('documentation-help-bulk-management-desc'),
            },
            {
              title: t('documentation-help-categories-title'),
              description: t('documentation-help-categories-desc'),
            },
            {
              title: t('favorites'),
              description: t('documentation-help-favorites-desc'),
            },
          ],
        },
        {
          chipLabel: t('documentation-help-section-search-access'),
          items: [
            {
              title: t('documentation-help-advanced-search-title'),
              description: t('documentation-help-advanced-search-desc'),
            },
            {
              title: t('documentation-help-qr-visibility-title'),
              description: t('documentation-help-qr-visibility-desc'),
            },
          ],
        },
        {
          chipLabel: t('documentation-help-section-operational'),
          items: [
            {
              title: t('documentation-help-attach-title'),
              description: t('documentation-help-attach-desc'),
            },
            {
              title: t('documentation-help-operational-access-title'),
              description: t('documentation-help-operational-access-desc'),
            },
            {
              title: t('documentation-help-form-question-title'),
              description: t('documentation-help-form-question-desc'),
            },
          ],
        },
        {
          chipLabel: t('documentation-help-section-governance'),
          items: [
            {
              title: t('documentation-help-access-control-title'),
              description: t('documentation-help-access-control-desc'),
            },
            {
              title: t('documentation-help-approval-title'),
              description: t('documentation-help-approval-desc'),
            },
            {
              title: t('documentation-help-renewal-title'),
              description: t('documentation-help-renewal-desc'),
            },
            {
              title: t('documentation-help-analytics-title'),
              description: t('documentation-help-analytics-desc'),
            },
          ],
        },
        // {
        //   chipLabel: t('documentation-help-section-addon'),
        //   intro: {
        //     title: t('documentation-help-ai-title'),
        //     description: t('documentation-help-ai-desc'),
        //   },
        //   items: [
        //     { title: t('documentation-help-ai-bullet-1') },
        //     { title: t('documentation-help-ai-bullet-2') },
        //     { title: t('documentation-help-ai-bullet-3') },
        //     { title: t('documentation-help-ai-bullet-4') },
        //   ],
        // },
      ],
    }),
    [t],
  );
}
